import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { documnetOwnerModel } from '../../Interfaces/index'

interface DocumentOwnerState {
  documentOwners: documnetOwnerModel[]
}

const initialState: DocumentOwnerState = {
  documentOwners: []
}

const documentOwnerSlice = createSlice({
  name: 'documentOwner',
  initialState,
  reducers: {
    setDocumentOwners(state, action: PayloadAction<documnetOwnerModel[]>) {
      state.documentOwners = action.payload
    }
  }
})

export const { setDocumentOwners } = documentOwnerSlice.actions
export const documentOwnerReducer = documentOwnerSlice.reducer
